import { motion } from 'framer-motion';
import { useExpressConsultant, useExpressLink } from '@/hooks/queries';
import { useCampaignStore } from '@/stores';

function initials(name: string) {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('');
}

/** Who sent this Express link, as the server names them. */
export function InvitedBy({ code }: { code: string }) {
  return <InvitedByName name={useExpressLink(code).data?.consultantName ?? null} />;
}

/** After sign-up: the Consultant whose link made the selected campaign, the one the send steps are for. */
export function CampaignInvitedBy() {
  const campaignId = useCampaignStore((s) => s.selectedCampaign?.id ?? null);
  return <InvitedByName name={useExpressConsultant(campaignId).data?.consultantName ?? null} />;
}

/** The space is held while the name loads, so nothing jumps. */
function InvitedByName({ name }: { name: string | null }) {
  return (
    <div className="flex h-8 min-w-0 items-center">
      {name && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className="flex min-w-0 items-center gap-2 rounded-full border bg-background py-1 pl-1 pr-3 text-sm text-foreground"
        >
          <span
            aria-hidden="true"
            className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-primary text-[11px] font-semibold text-primary-foreground"
          >
            {initials(name)}
          </span>
          <span className="truncate">Invited by {name}</span>
        </motion.p>
      )}
    </div>
  );
}
